import { render } from "./EmergencyOutHoursEventList.vue?vue&type=template&id=398eb6ae&scoped=true&ts=true"
import script from "./EmergencyOutHoursEventList.vue?vue&type=script&lang=ts"
export * from "./EmergencyOutHoursEventList.vue?vue&type=script&lang=ts"

import "./EmergencyOutHoursEventList.vue?vue&type=style&index=0&id=398eb6ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398eb6ae"]])

export default __exports__